import type { PackageStatusEnum } from "@/__generated__/graphql";
import { type PackageData } from "@/types/package";
import { create } from "zustand";

export type PackageStatusFilterItem = {
  label: string;
  value: PackageStatusEnum | "ALL";
};

type PackageListState = {
  packageList: PackageData[];
  packageData: PackageData | null;
  rowsPerPage: number;
  packageStatus: PackageStatusEnum | "ALL";
};

export const usePackageState = create<{
  data: PackageListState;
  setPackageList(packages: PackageData[]): void;
  setPackage(packageData: PackageData | null): void;
  setLimit(prevOffset: number): void;
  setPackageStatus(packageStatus: PackageStatusEnum | "ALL"): void;
}>((set, get) => ({
  data: {
    packageList: [],
    packageData: null,
    rowsPerPage: 5,
    packageStatus: "ALL",
    relatedVisitPackageFrom: null,
    relatedVisitPackageTo: null,
  },
  setPackageList: (packageList: PackageData[]) => {
    set({
      data: {
        ...get().data,
        packageList,
      },
    });
  },
  setPackage: (packageData: PackageData | null) => {
    set({
      data: {
        ...get().data,
        packageData,
      },
    });
  },
  setLimit: (prevOffSet: number) => {
    const updatedOffset = prevOffSet + 5;
    set({
      data: {
        ...get().data,
        rowsPerPage: updatedOffset,
      },
    });
  },
  setPackageStatus: (packageStatus: PackageStatusEnum | "ALL") => {
    set({
      data: {
        ...get().data,
        packageStatus,
      },
    });
  },
}));
